import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
  addEmptyExistingSystem,
  clearExistingEquipmentForNoAnswer
} from 'features/structure/structure-slice';
import { nanoid } from 'nanoid';
import { useEffect, useRef } from 'react';
import {
  AnchorSystemType,
  isStaleAnchorExistingSystem
} from 'utils/anchor-existing-system';

export default function useEnsureAnchorExistingSystemOfType(
  anchorType: AnchorSystemType | null
) {
  const dispatch = useAppDispatch();
  const existingSystems = useAppSelector(
    (state) => state.structure.existingSystems
  );
  const anchorCreatedRef = useRef(false);

  useEffect(() => {
    if (anchorType === null) return;
    if (isStaleAnchorExistingSystem(existingSystems, anchorType)) {
      anchorCreatedRef.current = false;
      dispatch(clearExistingEquipmentForNoAnswer());
      return;
    }
    if (existingSystems.length > 0 || anchorCreatedRef.current) return;
    anchorCreatedRef.current = true;
    dispatch(addEmptyExistingSystem({ uniqueId: nanoid(5), type: anchorType }));
  }, [anchorType, existingSystems, dispatch]);
}
